import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { checkEvent } from "@mainaction";

const MainContainer = (props) => {
  let { routes, session } = props;

  useEffect(() => {
    props.checkEvent(session);
  }, []);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (
        prop.layout === "/admin" &&
        (prop.section === "both" || prop.section === session?.usertype)
      ) {
        return <Route path={prop.path} element={prop.component} key={key} />;
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <Routes>{getRoutes(routes)}</Routes>
    </>
  );
};

const mapStateToProps = (state) => {
  return { isLoggedIn: state.isLoggedIn, session: state.session };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ checkEvent }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MainContainer);
